import React from 'react';
import './guide.css';

import { useNavigate } from 'react-router-dom';

import chromePrint from './chrome_print.png';
import pdf24Printer from './pdf24_printer.png';


function Guide() {

    const navigate = useNavigate();


    return (

        <div className="guide-wrapper">
            <h1 className="guide-title">
                GUIDE & MANUALI
            </h1>

            <div className="guide-index">

            <h2>Sommario</h2>
                <ul>
                <li>
                <a href="#stampa-report">
                1. Configurazioni di stampa
                </a>
                <ul>
                <li>
                <a href="#apertura-report">
                1.1 Browser predefinito consigliato
                </a>
                </li>
                <li>
                <a href="#apertura-stampa">
                1.2 Apertura impostazioni di stampa e configurazione
                </a>
                </li>
                <li>
                <a href="#impostazioni-stampa">
                1.3 Impostazioni consigliate
                </a>
                </li>
                <li>
                <a href="#pdf24">
                1.4 Selezione PDF24
                </a>
                </li>
                </ul>
                </li>
                <li>
                <a href="#browser">
                2. Configurazione browser
                </a>
                <ul>
                <li>
                <a href="#aggiornamento-browser">
                2.1 Verifica e aggiornamento Google Chrome
                </a>
                </li>
                </ul>
                </li>
                <li>
                <a href="#problemi">
                3. Problemi comuni
                </a>
                </li>
                </ul>
            </div>

        <section id="stampa-report">
            <h2 className="guide-section-title">
            1. Configurazioni di stampa
            </h2>
            <p>
                Questa procedura descrive la corretta modalità di stampa dei report
                generati da V.E.S., permettendo di ottenere un file PDF conforme
                all'impaginazione prevista, mantenendo formattazione, grafici e tabelle.
            </p>
            <h3 id="apertura-report">
            1.1 Browser predefinito consigliato
            </h3>
            <p>
                Per una corretta visualizzazione e stampa dei report generati da V.E.S.
                si consiglia di utilizzare Google Chrome come browser predefinito.
            </p>
            <p>
                Verificare che Chrome sia aggiornato all'ultima versione disponibile
                e che il report venga aperto correttamente prima di procedere con la stampa.
            </p>

        <h3 id="apertura-stampa">
        1.2 Apertura impostazioni di stampa e configurazione
        </h3>
            <p>
                Per accedere alle impostazioni di stampa del browser utilizzare
                la combinazione:
            </p>

            <div className="shortcut">
                CTRL + P
            </div>
            <p>
                Si aprirà la finestra di anteprima stampa del browser.
                Da questa schermata è possibile verificare l'anteprima del report
                e configurare i parametri necessari per ottenere un PDF corretto.
            </p>
            <img
                src={chromePrint}
                alt="Configurazione stampa Chrome"
                style={{
                    width: '20%',
                    height: 'auto',
                    display: 'block',
                    margin: '25px auto'
                }}
            />

        <h3 id="impostazioni-stampa">
        1.3 Impostazioni consigliate
        </h3>
            <ul className="settings-list">
            <li>
            Formato pagina: A4
            </li>
            <li>
            Orientamento: Verticale
            </li>
            <li>
            Scala: 100%
            </li>
            <li>
            Margini: Predefiniti
            </li>
            <li>
            Attivare: Grafica di sfondo
            </li>
            </ul>
        <h3 id="pdf24">
        1.4 Selezione PDF24
        </h3>
            <p>
            Se disponibile nel computer, selezionare la stampante virtuale:
            </p>
            <div className="printer-box">
            PDF24 PDF
            </div>
            <img
            src={pdf24Printer}
            alt="Selezione stampante PDF24"
            className="guide-image"
            />
            <p>
            PDF24 permette di creare un file PDF mantenendo
            la qualità e l'impaginazione del report.
            </p>
        </section>

        <section id="browser">
        <h2 className="guide-section-title">
        2. Configurazione browser
        </h2>
            <p>
            Per una corretta visualizzazione e stampa dei report generati da V.E.S.
            utilizzare preferibilmente Google Chrome aggiornato.
            </p>
            <h3 id="aggiornamento-browser" className="guide-subtitle">
            2.1 Verifica e aggiornamento Google Chrome
            </h3>
            <p>
            Per verificare la versione installata e procedere con l'aggiornamento:
            </p>
            <ol>
            <li>
            Aprire Google Chrome.
            </li>
            <li>
            Cliccare sul menu in alto a destra
            <b>⋮</b>.
            </li>
            <li>
            Selezionare:
            <br/>
            <b>Guida → Informazioni su Google Chrome</b>
            </li>
            <li>
            Chrome controllerà automaticamente la disponibilità di aggiornamenti.
            </li>
            <li>
            Se disponibile, premere il pulsante:
            <br/>
            <b>Riavvia</b>
            <br/>
            per completare l'aggiornamento.
            </li>
            </ol>
            <p>
            In alternativa è possibile aprire direttamente la pagina di aggiornamento
            digitando nella barra degli indirizzi:
            </p>
            <div className="shortcut">
            chrome://settings/help
            </div>
            <p>
            Al termine verificare che venga visualizzato il messaggio:
            <b> "Google Chrome è aggiornato"</b>.
            </p>
            <p>
            Evitare l'utilizzo di versioni obsolete del browser perché possono modificare
            la visualizzazione del report e la corretta gestione delle impostazioni
            di stampa.
            </p>
        </section>

        <section id="problemi">
        <h2 className="guide-section-title">
        3. Problemi comuni
        </h2>
            <h3>
            Orientamento pagine errato
            </h3>
            <p>
            Controllare configurazioni al paragrafo 1.2
            </p>
            <h3>
            I colori non vengono stampati
            </h3>
            <p>
            ontrollare configurazioni al paragrafo 1.2
            </p>
            <h3>
            Il problema perisite
            </h3>


            <p>

            <span
                onClick={() => navigate('/Ticket')}
                style={{
                    cursor: 'pointer',
                    color: '#1c5fa8',
                    fontWeight: 'bold',
                    textDecoration: 'underline'
                }}
            >
                Apri un ticket di assistenza
            </span>

            </p>
            </section>
        </div>
        );
    }

export default Guide;